import React from 'react';
import Chart from "react-apexcharts";

interface Iprops {
  years?: any[],
  series?: any[]
}

const ClusteredBarChart = ({
  years,
  series
}: Iprops) => {
  
  
  const options: any = {
    series: series,
    chart: {
      type: 'bar',
      height: 500,
    //   stacked: true,
    },
    plotOptions: {
      bar: {
        barHeight: 30,
        columnWidth: "40%",
        // horizontal: true,
        // dataLabels: {
        //   total: {
        //     enabled: true,
        //     offsetX: 0,
        //     style: {
        //       fontSize: '14px',
        //       fontWeight: 900
        //     }
        //   }
        // }
      },
    },
    dataLabels: {
        enabled: false
    },
    colors: [
      "#65A30D",
      "#F59E0B",
      "#B91C1C",
    ],
    stroke: {
      width: 1,
      colors: ['#fff']
    },
    xaxis: {
      categories: years,
      labels: {
        formatter: function (val:string) {
          return val
        }
      }
    },
    yaxis: {
        title: {
            text: 'Volume / Quanity'
        },
        labels: {
          formatter: function (val:string) {
            return `${val} m3`
          }
        }
    },
    tooltip: {
      y: {
        formatter: function (val:string) {
          return val
        }
      }
    },
    fill: {
      opacity: 1
    },
    legend: {
      position: 'bottom',
      horizontalAlign: 'center',
      offsetX: 0
    }
  };

  return (
    <div className="chart-wrapper">
      <Chart
        options={options}
        series={options.series}
        type="bar"
        height="220"
      />
    </div>
  )
}

export default ClusteredBarChart;